/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_C3Inputs */

const en_guide_json_syntax_errors_c3 = /** @type {(inputs: Guide_Json_Syntax_Errors_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locating the exact character a parser choked on`)
};

const ko_guide_json_syntax_errors_c3 = /** @type {(inputs: Guide_Json_Syntax_Errors_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파서가 걸린 정확한 문자를 찾아내는 방법`)
};

const ja_guide_json_syntax_errors_c3 = /** @type {(inputs: Guide_Json_Syntax_Errors_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーサーが詰まった正確な文字を突き止める方法`)
};

/**
* | output |
* | --- |
* | "Locating the exact character a parser choked on" |
*
* @param {Guide_Json_Syntax_Errors_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_c3 = /** @type {((inputs?: Guide_Json_Syntax_Errors_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_c3(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_c3(inputs)
	return ja_guide_json_syntax_errors_c3(inputs)
});